import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { BehaviorSubject, Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appDropFiles]',
  host: {
    style: 'position: relative;'
  }
})
export class DropFilesDirective {
  @Input() disabled: boolean;
  @Input() private extensiones: Array<string> = ['jpeg', 'jpg', 'pdf'];
  @Output() private filesChangeEmiter: EventEmitter<File[]> = new EventEmitter();

  @HostBinding('class.drag-target') get valid() { return this.showDiv.value; }

  divCovert: HTMLDivElement = document.createElement('div');
  divCovertInnerHtml = `
    <div class="flex flex-col items-center justify-center shadow-inner overflow-hidden h-full bg-[#EFF0F0] rounded-[8px] border border-[#98A4AE] text-[#5A646E]">
      <div class="material-icons !text-[48px]">cloud_upload</div>
      <div class="text-center">Arrastra los archivos aquí <br> (max. 5)</div>
    </div>
  `;
  classCovert = 'absolute top-0 bottom-0 left-0 right-0 hidden';
  inViewDrop = false;

  showDiv = new BehaviorSubject(false);

  /** mientras este dragover debería skipear el leave si es que sucede */
  skip = new Subject<void>();

  constructor(_el: ElementRef) {
    this.divCovert.className = this.classCovert;
    this.divCovert.innerHTML = this.divCovertInnerHtml;
    const el = _el.nativeElement as HTMLElement;
    el.appendChild(this.divCovert);
    this.showDiv.pipe().subscribe(resp => {
      if (this.disabled) return;
      if (resp) {
        this.divCovert.classList.remove('hidden');
      } else {
        this.divCovert.classList.add('hidden');
      }
    })
  }

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.skip.next();
  }

  @HostListener('dragenter', ['$event']) public onDragEnter(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.showDiv.next(true);
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    timer(200).pipe(takeUntil(this.skip)).subscribe(() => {
      this.showDiv.next(false);
    });
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    if (this.disabled) {
      this.showDiv.next(false);
      return;
    }
    const files = evt.dataTransfer.files as FileList;
    const valid_files = this.validFiles(Array.from(files));
    this.filesChangeEmiter.emit(valid_files);
    this.showDiv.next(false);
  }

  validFiles(files: File[]) {
    return files.filter(f => this.checkType(f.type))
  }

  checkType(type: string) {
    return this.extensiones.some(ext => type.includes(ext));
  }

}